module.exports = __webpack_public_path__ + "static/media/511G+1NOgQL._AC_UX569_.a5296a35.jpg";